// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateAgentMarketingProfileSlug(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AgentMarketingProfileSlugUpdated"]);
}

let variablesConverter = {"updateAgentMarketingProfileSlugInput":{},"__root":{"input":{"r":"updateAgentMarketingProfileSlugInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateAgentMarketingProfileSlug_AgentMarketingProfileSlugUpdated_marketingProfile_publicUrl":{"b":""},"updateAgentMarketingProfileSlug_AgentMarketingProfileSlugUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileSlug":{"u":"response_updateAgentMarketingProfileSlug"}}};

let wrapResponseConverterMap = {
  response_updateAgentMarketingProfileSlug: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateAgentMarketingProfileSlug_AgentMarketingProfileSlugUpdated_marketingProfile_publicUrl":{"b":""},"updateAgentMarketingProfileSlug_AgentMarketingProfileSlugUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileSlug":{"u":"response_updateAgentMarketingProfileSlug"}}};

let responseConverterMap = {
  response_updateAgentMarketingProfileSlug: unwrap_response_updateAgentMarketingProfileSlug
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfileSlugFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileSlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentMarketingProfileSlugForm_form_agentMarketingProfile"
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileSlugUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentMarketingProfileSlugFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileSlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketingProfileURLDetails",
                    "kind": "LinkedField",
                    "name": "urlDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "baseUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileSlugUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa54644def66025a391e441adc12d4ac",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfileSlugFormMutation",
    "operationKind": "mutation",
    "text": "mutation AgentMarketingProfileSlugFormMutation(\n  $input: UpdateAgentMarketingProfileSlugInput!\n) {\n  updateAgentMarketingProfileSlug(input: $input) {\n    __typename\n    ... on AgentMarketingProfileSlugUpdated {\n      marketingProfile {\n        ...AgentMarketingProfileSlugForm_form_agentMarketingProfile\n        publicUrl\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfileSlugForm_form_agentMarketingProfile on AgentMarketingProfile {\n  publicUrl\n  urlDetails {\n    baseUrl\n    slug\n  }\n}\n"
  }
};
})());

let wrap_response_updateAgentMarketingProfileSlug = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentMarketingProfileSlug = unwrap_response_updateAgentMarketingProfileSlug;
exports.wrap_response_updateAgentMarketingProfileSlug = wrap_response_updateAgentMarketingProfileSlug;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
